import { NoAccessError } from '@/generic_api/lib/errors'

const log = () => {} // console.log
// const log = (...args) => { console.log("[task]", ...args) }

function get_goal_id( $store ) {
  if ( !( 'goalId' in $store.definedProps ) ) {
    throw new Error('Please define goalId in "with".')
  }

  return $store.definedProps[ 'goalId' ]
}

function check_phantom_task( task ) {
  if ( Object.keys( task.$state ).length === 1 && task.$state.sortidx ) {
    // console.log("[task:check_phantom_task] Found Phantom-task", JSON.stringify(task.$state))
    return true
  }
  return false
}

/*function make_buckets( commitments ) {
  // TODO:
}*/

function push_to_bucket( buckets, task, bucketId, memberId ) {
  log("[push_to_bucket] Pushing task to bucket", task, bucketId);

  // TODO: Make sure commitment exists, otherwise put into null-bucket

  if ( !( bucketId in buckets ) ) {
    buckets[ bucketId ] = []
  }

  if ( check_phantom_task( task ) ) {
    return
  }

  /* Save member id in task, so we know it's origin later on */
  task.memberId = memberId;

  buckets[ bucketId ].push(task)
}

export default {
  abstract_store: true,

  modelGetters: {
    /* modelGetters are not supported yet in abstract stores */
  },

  modelActions: {
    /* modelActions are not supported yet in abstract stores */
  },

  listGetters: {
    /* listGetters are not supported yet in abstract stores */
  },

  listActions: {
    /* listActions are not supported yet in abstract stores */
  },

  staticGetters: {

    /**
     * get_last_sortidx - returns last sortidx
     */
    get_last_sortidx: ($models, $registry, $store) => {
      // TODO

      if ( !( 'goalId' in $store.definedProps ) ) {
        throw new Error('Please define goalId in "with".')
      }

      let goalId = $store.definedProps[ 'goalId' ]
      let laneId = $store.definedProps[ 'laneId' ]
      let userId = $models.user.defaultUserId

      let task_meta_list = $models.taskMeta
            .with({ goalId: goalId, uid: userId })
            .getList()
            .asArrayFilteredBy('laneId', laneId)

      let array = task_meta_list.items;

      if ( array.length > 0 ) {
        let last_sort_idx = array.reduce((p, v) => ( p.sortidx  > v.sortidx  ? p : v ) )
        return last_sort_idx.sortidx + 100;
      } else {
        return 100;
      }
    },

    /* lane_task_list - Get all tasks for a certain lane based on access rights
     *
     * Usage:
     * this.$models.task.with({ goalId }).getters.lane_task_list_current_user
     *
     */
    lane_task_list_all_users: ( $models, $registry, $store ) => {

      let goalId = get_goal_id( $store );

      let goal_members = $models.goalMember.with({ goalId }).getList();

      if ( !goal_members.$readyAll ) {
        throw new Error('Goal members not ready')
      }

      let tasklist_grouped_by_commitment_id = {}

      /* Read access tab from goal meta */
      let access_tab = $models.goalMemberPrivacySettings
                   .with({ goalId })
                   .getAccessTab()

      log("[lane_task_list_all_users] Using access_tab", access_tab);

      for ( let memberId in access_tab ) {
        let allow_to_see_tasks = access_tab[ memberId ].allow_to_see_tasks
        log("[lane_task_list_all_users] Allowed to see tasks for member", memberId, allow_to_see_tasks);

        /* Check if we're allowed to see tasks, otherwise skip */
        if ( !allow_to_see_tasks ) {
          continue;
        }

        let task_list = $models.taskMeta
                .with({ goalId: goalId, uid: memberId })
                .getList()

        /* Task list has not been loaded. */
        if ( task_list === null || !task_list.$readyAll ) {
          console.warn("Trying to fetch tasklist, that has not been loaded")
          continue
        }

        task_list.asArraySorted().items.forEach(task => {
          let laneId = task.laneId || null;
          push_to_bucket( tasklist_grouped_by_commitment_id, task, laneId, memberId );
        })
      }

      log("[lane_task_list_all_users] result", tasklist_grouped_by_commitment_id)
      return tasklist_grouped_by_commitment_id
    },

    /* lane_task_list - Get all tasks for a certain lane based on access rights
     *
     * Usage:
     * this.$models.task.with({ goalId }).getters.lane_task_list_current_user
     *
     */
    // lane_task_list({ $store, $models }, current_user_only = false ) {
    lane_task_list_current_user: ( $models, $registry, $store ) => {

      let goalId = get_goal_id( $store );
      const myUserId = $models.user.defaultUserId

      let task_list = $models.taskMeta
              .with({ goalId: goalId, uid: myUserId })
              .getList()

      /* Task list has not been loaded. */
      if ( task_list === null || !task_list.$readyAll ) {
        console.warn("Trying to fetch tasklist, that has not been loaded")
        return
      }

      let tasklist_grouped_by_commitment_id = {}
      task_list.asArraySorted().items.forEach(task => {
        let laneId = task.laneId || null;
        push_to_bucket( tasklist_grouped_by_commitment_id, task, laneId, myUserId );
      })

      log("[lane_task_list_current_user] result", tasklist_grouped_by_commitment_id)
      return tasklist_grouped_by_commitment_id
    },
  },

  staticActions: {

    /* subscribe_to_goal_tasks - Subscribe to all tasks within a goal that I have access to
     *
     *
     */
    subscribe_to_goal_tasks({ $store, $models }, goalId ) {

      // TODO: Check if goal is ready

      /* Read access tab from goal meta and subscribe to each bucket task list */
      let access_tab = $models.goalMemberPrivacySettings
                   .with({ goalId })
                   .getAccessTab()

      let promise_list = []
      for ( let memberId in access_tab ) {
        if ( access_tab[ memberId ].allow_to_see_tasks ) {
           let task_list = $models.taskMeta
                .with({ goalId: goalId, uid: memberId })
                .subscribeList()
           promise_list.push( task_list.$promise )
        }
      }

      return Promise.all(promise_list);
    },

    /* get_lane_task_list - Get all tasks for a certain lane based on access rights
     *
     * Usage:
     * this.$models.task.with({ goalId }).get_lane_task_list()
     *
     * TODO: Rename to fetch_lane_task_list and fetch instead of subscribe
     *       (We need another solution for initial subscribe then)
     * TODO: Refactor: IT WOULD BE EASIER TO JUST PASS THE GOALID
     *
     */
    get_lane_task_list({ $store, $models }, current_user_only = false ) {

      // TODO: What happens if this is called twice??
      // TODO: This will result in every lane getting re-rendered after EACH update!
      // TODO: Maybe have a getter for each lane ?

      if ( !( 'goalId' in $store.definedProps ) ) {
        throw new Error('Please define goalId in "with".')
      }

      let goalId = $store.definedProps[ 'goalId' ]

      let goal_members = $models.goalMember.with({ goalId }).getList();

      if ( !goal_members.$readyAll ) {
        throw new Error('Goal members not ready')
      }

      let tasklist_grouped_by_commitment_id = {}
      let promise_list = [];

      let access_tab = {}
      if ( current_user_only ) {
        /* Creat a "fake" access tab containing only the current user */
        const my_user_id = $models.user.defaultUserId
        access_tab = {
          [my_user_id]: { allow_to_see_tasks: true }
        }
      } else {
        /* Read access tab from goal meta */
        access_tab = $models.goalMemberPrivacySettings
                     .with({ goalId })
                     .getAccessTab()
      }

      log("[get_lane_task_list] Using access_tab", access_tab);

      for ( let memberId in access_tab ) {
        let allow_to_see_tasks = access_tab[ memberId ].allow_to_see_tasks
        log("[get_lane_task_list] Allowed to see tasks for member", memberId, allow_to_see_tasks);

        /* Check if we're allowed to see tasks, otherwise skip */
        if ( !allow_to_see_tasks ) {
          continue;
        }

        let task_list = $models.taskMeta
                .with({ goalId: goalId, uid: memberId })
                .subscribeList()

        /* Task list has alredy been loaded. This means we can diretly map the
         * results to the commitment buckets, without dealing with promises */
        if ( task_list.$readyAll ) {
          log("[get_lane_task_list] Not waiting for task_list, is ready", task_list);

          task_list.asArraySorted().items.forEach(task => {
            let laneId = task.laneId || null;
            push_to_bucket( tasklist_grouped_by_commitment_id, task, laneId, memberId );
          })
          continue; /* continue with members task lists! */
        }

        log("[get_lane_task_list] Waiting for task_list", task_list);

        /* As soon as task list is loaded map data to by commitment id */
        let taskListPromise = task_list.$promise.then(() => {
          log("[get_lane_task_list] Got task_list", task_list);
          task_list.asArraySorted().items.forEach(task => {
            let laneId = task.laneId || null;
            push_to_bucket( tasklist_grouped_by_commitment_id, task, laneId, memberId );
          })
        })
        promise_list.push( taskListPromise );
      }

      let promiseAll = Promise.all(promise_list).then(() => {
        return tasklist_grouped_by_commitment_id;
      })

      return {
        items: tasklist_grouped_by_commitment_id,
        $promise: promiseAll
      }
    },

    /* get_phantom_tasks - Get all phantom tasks
     *                     ** Can only be run by goal admin **
     *
     */
    fetch_phantom_tasks({ $store, $models }, goalId) {

      let goal_members = $models.goalMember.with({ goalId }).getList()

      if ( !goal_members.$readyAll ) {
        throw new Error('Goal members not ready')
      }

      if ( !goal_members.items[ $models.user.defaultUserId ].isAdmin ) {
        throw new Error('get_phantom_tasks can only be called by admin')
      }

      let promise_list = []
      let phantom_task_list = []

      for ( let memberId of goal_members.$id_list ) {
        let task_list = $models.taskMeta
              .with({ goalId: goalId, uid: memberId })
              .fetchList()

        task_list.$promise.then(() => {
          task_list.itemsAsArray().forEach(task => {
            if ( check_phantom_task( task ) ) {
              task.memberId = memberId;
              phantom_task_list.push( task )
            }
          })
        });
        promise_list.push( task_list.$promise )
      }

      return Promise.all(promise_list).then(() => {
        return phantom_task_list
      });
    },

    /* getNodeFull - Get fullt task with access rights
     *
     * Usage:
     * this.$models.task.with({ goalId, memberId }).getNodeFull( taskId )
     *
     */
    getNodeFull({ $store, $models }, taskId, include_task_details = false, include_checklist = false ) {

      const log = () => {} // console.log

      if ( !( 'goalId' in $store.definedProps ) ) {
        throw new Error('Please define goalId in "with".')
      }

      if ( !( 'memberId' in $store.definedProps ) ) {
        throw new Error('Please define memberId in "with".')
      }

      let goalId = $store.definedProps.goalId;
      let memberId = $store.definedProps.memberId;

      log("[getNodeFull]: goalId", goalId, "memberId", memberId, "taskId", taskId);

      const access_tab = $models.goalMemberPrivacySettings.with({ goalId }).getAccessTab()
      const task_access = access_tab[ memberId ]

      log("[getNodeFull]: access_tab", access_tab, "task_access", task_access);

      if ( task_access && !task_access.allow_to_see_tasks ) { // TODO: "allow_to_see_task_details"
        throw new NoAccessError('Current user has no access to tasks owned by user', memberId)
      }

      let task_meta = $models.taskMeta.with({
        goalId: goalId,
        uid:    memberId,
      }).subscribeNode( taskId )

      task_meta.access = task_access;

      if ( include_task_details ) {
        let task_details = $models.taskDetails.with({
          goalId: goalId,
          uid:    memberId,
        }).subscribeNode( taskId )
        task_meta.details = task_details
      }

      if ( include_checklist ) {
        let task_checklist_items = $models.taskChecklistItem.with({
          goalId: goalId,
          taskId: taskId,
          uid:    memberId,
        }).subscribeList()
        task_meta.checklist_items = task_checklist_items
      }

      if ( include_task_details || include_checklist) {
        task_meta.$promise = Promise.all([
          task_meta.$promise,
          (task_meta.details || {}).$promise,
          (task_meta.checklist_items || {}).$promise,
        ])
      }

      return task_meta;
    }
  },
};
